export const ROUTE_LOGIN_OUT = "/login";
export const ROUTE_HOME = "/home";
export const ROUTE_TASKS = "/tasks";
export const ROUTE_TIMERS = "/timers";
export const ROUTE_INBOX = "/inbox";
export const ROUTE_SEARCH = "/search";
export const ROUTE_TAGS = "/tags";
export const ROUTE_METRICS = "/metrics";
export const ROUTE_PROFILE = "/profile";
